import React, { useState } from 'react';
import { Card, Table, Button, ButtonGroup } from 'react-bootstrap';
import moment from 'moment';

const formatDate = (d) => (d ? moment(d).format('DD/MM/YYYY') : '');
const formatMoney = (v) =>
  v != null
    ? Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : '-';

const GridTitulos = ({
  titulos,
  titulosAlterados,
  onNovaDataChange,
  onLancar,
  onCancelar,
  loading,
}) => {
  const [editando, setEditando] = useState({});
  const [editValor, setEditValor] = useState({});

  const handleCelulaFocus = (codigoTitulo) => {
    const atual = titulosAlterados[codigoTitulo] ? formatDate(titulosAlterados[codigoTitulo]) : '';
    setEditando((prev) => ({ ...prev, [codigoTitulo]: true }));
    setEditValor((prev) => ({ ...prev, [codigoTitulo]: atual }));
  };

  const handleCelulaBlur = (codigoTitulo, valorAnterior) => {
    const val = editValor[codigoTitulo] || '';
    const regex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (val && !regex.test(val)) {
      onNovaDataChange(codigoTitulo, valorAnterior);
    } else if (val) {
      const parsed = moment(val, 'DD/MM/YYYY', true);
      if (!parsed.isValid()) {
        onNovaDataChange(codigoTitulo, valorAnterior);
      } else {
        onNovaDataChange(codigoTitulo, parsed.toISOString());
      }
    }
    setEditando((prev) => ({ ...prev, [codigoTitulo]: false }));
  };

  return (
    <Card className="mb-2">
      <Card.Header className="py-1 d-flex justify-content-between align-items-center">
        <strong>Títulos Elegíveis ({titulos.length})</strong>
        <ButtonGroup>
          <Button variant="success" onClick={onLancar} disabled={loading}>
            Lançar
          </Button>
          <Button variant="outline-secondary" onClick={onCancelar} disabled={loading}>
            Cancelar
          </Button>
        </ButtonGroup>
      </Card.Header>
      <Card.Body className="p-0">
        <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '60vh' }}>
          <Table striped bordered hover className="mb-0">
            <thead>
              <tr>
                <th>Nº Ordem</th>
                <th>Tipo</th>
                <th>Valor</th>
                <th>Líquido</th>
                <th>Vencimento Atual</th>
                <th>Novo Vencimento</th>
                <th>Prorrogações</th>
              </tr>
            </thead>
            <tbody>
              {titulos.map((titulo) => {
                const novaData = titulosAlterados[titulo.codigo_titulo];
                const novaDataFormatada = novaData ? formatDate(novaData) : '';
                const isEditando = editando[titulo.codigo_titulo];

                return (
                  <tr key={`${titulo.codigo_titulo}`}>
                    <td>{titulo.numero_de_ordem}</td>
                    <td>{titulo.tipo}</td>
                    <td className="text-right">{formatMoney(titulo.valor)}</td>
                    <td className="text-right">{formatMoney(titulo.liquido)}</td>
                    <td>{formatDate(titulo.data_vencimento)}</td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        style={{ minWidth: '110px' }}
                        value={isEditando ? (editValor[titulo.codigo_titulo] || '') : novaDataFormatada}
                        placeholder="dd/mm/aaaa"
                        onFocus={() => handleCelulaFocus(titulo.codigo_titulo)}
                        onChange={(e) => {
                          const novoValor = e.target.value;
                          setEditValor((prev) => ({
                            ...prev,
                            [titulo.codigo_titulo]: novoValor,
                          }));
                        }}
                        onBlur={() => handleCelulaBlur(titulo.codigo_titulo, novaData)}
                      />
                    </td>
                    <td className="text-center">{titulo.prorrogacoes}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridTitulos;
